import { gsap } from 'gsap';

export function initGetStartedLight() {
  const parent = document.querySelector('.get-started-light');
  if (!parent) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: parent,
      start: 'top 65%',
      toggleActions: 'play none none none',
      // markers: true,
    },
    defaults: { ease: 'power4.out' },
  });

  tl.from('.get-started-light__heading1', {
    y: 40,
    opacity: 0,
    duration: 0.8,
  });
  tl.fromTo(
    '.get-started-light__heading2',
    {
      // use wv because of inline wrap
      clipPath: 'polygon(-50vw -50vh, -50vw -50vh, -50vw 50vh, -50vw 50vh)',
    },
    {
      clipPath: 'polygon(-50vw -50vh, 50vw -50vh, 50vw 50vh, -50vw 50vh)',
      duration: 1.2,
    },
    '-=0.4',
  );

  tl.from(
    '.get-started-light__text',
    {
      opacity: 0,
      duration: 1.2,
    },
    '-=0.4',
  );
  tl.from(
    '.get-started-light__btns',
    {
      opacity: 0,
      duration: 1.2,
    },
    '<',
  );
}
